import React from "react";
import Fade from "react-reveal/Fade";
import SectionWrapper, {
  Container,
  Title,
  LogoGrid,
  LogoItem,
} from "./featuredIn.style";

const FeaturedIn = () => {
  const logos = [
    {
      name: "Zee News",
      src: "/Zee_News_2025.svg.png",
      link: "https://zeenews.india.com/consumer-connect/common-myths-about-hair-patches-and-what-people-should-know-3028052.html",
    },
    {
      name: "Orange City Times",
      src: "/white-orange-city-times.svg",
      link: "https://orangecitytimes.com/why-hair-wigs-are-becoming-part-of-delhis-urban-lifestyle-shift/",
    },
    {
      name: "Business News This Week",
      src: "/Business-News-This-Week-logos.jpeg",
      link: "https://businessnewsthisweek.com/fashion/the-new-conversation-around-hair-loss-and-confidence-among-modern-men/",
    },
    {
      name: "Sangri Today",
      src: "/amp-logo.webp",
      link: "https://www.sangritoday.com/spotlight/the-growing-trend-of-hair-patch-and-wig-solutions-in-urban-india",
    },
    {
      name: "ANI News",
      src: "/Ani-logo-black.png",
      link: "https://aninews.in/news/business/why-hair-wigs-in-delhi-are-becoming-a-preferred-grooming-choice20260526143610/",
    },
    {
      name: "Media Newsposts",
      src: "/medianewsposts.png",
      link: "https://medianewsposts.com/common-buying-mistakes-that-inflate-hair-wigs-price-over-time/",
    },
    {
      name: "Net News Ledger",
      src: "/NetNewsLedger.png",
      link: "https://www.netnewsledger.com/2026/08/07/is-a-low-hair-patch-price-in-delhi-a-red-flag-how-to-read-quality-signals/",
    },
  ];

  return (
    <SectionWrapper id="featured-in" className="pt-0">
      <Container>
        <Fade bottom>
          <Title>Press Releases & Media Presence</Title>
        </Fade>
        <LogoGrid>
          {logos.map((logo, index) => (
            <LogoItem key={`featured-logo-${index}`}>
              <Fade bottom delay={index * 100}>
                <a href={logo.link} target="_blank" rel="noopener noreferrer">
                  <img src={logo.src} alt={logo.name} />
                </a>
              </Fade>
            </LogoItem>
          ))}
        </LogoGrid>
      </Container>
    </SectionWrapper>
  );
};

export default FeaturedIn;
